import * as React from "react";
import { forwardRef } from "react";
const SvgRightDoubleIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 26 26", ref, ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "2.049,0.58 -0.035,2.664 10.801,13.5 -0.035,24.336 2.049,26.42 14.969,13.5  " }), /* @__PURE__ */ React.createElement("polygon", { points: "13.049,0.58 10.965,2.664 21.801,13.5 10.965,24.336 13.049,26.42 25.969,13.5  " }));
const ForwardRef = forwardRef(SvgRightDoubleIcon);
export default ForwardRef;
